import { ANIMATION_TYPES } from '@website-editor/context/NavigationPaneContext/NavigationPane.constants';
import { CUSTOM_PAGE_ACTIONS } from '@website-editor/customComponents/CustomComponents.constants';

export enum RICH_TEXT_ACTIONS {
  RICH_TEXT_ADD = 'rich_text_add',
  RICH_TEXT_EDIT = 'rich_text_edit',
}

export const RICH_TEXT_SCREENS = [RICH_TEXT_ACTIONS.RICH_TEXT_ADD, RICH_TEXT_ACTIONS.RICH_TEXT_EDIT];

export const RICH_TEXT_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [
    {
      navigatedFrom: RICH_TEXT_ACTIONS.RICH_TEXT_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: RICH_TEXT_ACTIONS.RICH_TEXT_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD]: [
    {
      navigatedFrom: RICH_TEXT_ACTIONS.RICH_TEXT_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: RICH_TEXT_ACTIONS.RICH_TEXT_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [RICH_TEXT_ACTIONS.RICH_TEXT_ADD]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [RICH_TEXT_ACTIONS.RICH_TEXT_EDIT]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
};
